<template>
  <div>
    <breadcrumb-header :items="breadcrumbs" />
    <loading-spinner v-if="(loadingCount > 0) || !teams" />
    <div
      v-else
    >
      <div
        v-for="(team) in teams"
        :key="team.id"
      >
        <v-divider class="mt-2" />
        <div class="d-flex flex-row justify-space-between align-center">
          <div class="text-headline-medium mt-1">
            {{ team.name }}
          </div>
          <div class="my-1">
            <team-edition-dialog
              v-if="can('manage_teams') || (authUser.id == team.overseer?.id)"
              mode="edit"
              :model-id="team.id"
              @reload="loadTeamsData"
            />
          </div>
        </div>
        <v-divider class="mt-1" />
        <rich-text-content
          v-if="team.description_visible && team.description"
          :data="team.description"
          class="mt-2"
        />

        <v-row class="mb-10">
          <v-col
            v-if="team.overseer"
            cols="12"
            sm="6"
            md="4"
          >
            <member-card
              class="mt-3"
              :title="team.overseer_title ?? t('global.overseer')"
              :user="team.overseer"
              fill-height
            />
          </v-col>

          <v-col
            v-for="member in team.members"
            :key="member.id"
            cols="12"
            sm="6"
            md="4"
          >
            <member-card
              class="mt-3"
              :title="member.pivot.role"
              :user="member"
              :heading-color="member.pivot.primary_color ? 'primary' : 'grey'"
              :description="member.pivot.role_description"
              fill-height
            />
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import axios from 'axios';
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import RichTextContent from '@/components/rich-text/RichTextContent.vue';
import { useAuth, usePermissions } from '@/composables';
import { useErrorStore } from '@/stores/errors';
import MemberCard from './MemberCard.vue';
import TeamEditionDialog from './TeamEditionDialog.vue';

const { t } = useI18n();

const { authUser } = useAuth();
const { can } = usePermissions();
const { handleError } = useErrorStore();

const teams = ref<Array<App.Models.Team>>([]);
const loadingCount = ref(0);

async function loadTeamsData() {
  loadingCount.value += 1;
  try {
    const response = await axios.get('/api/teams/affiliated');
    teams.value = response.data.data;
  }
  catch (error) {
    handleError(error, t('team.cannot_load'));
  }
  finally {
    loadingCount.value -= 1;
  }
}
const breadcrumbs = computed(() => [{ title: t('team.title', 2) }]);

loadTeamsData();
</script>
